module.exports = __webpack_public_path__ + "static/media/app-window.a47d8004.svg";